import * as React from "react";

function Logo() {
  return (
    <svg
      width="158"
      height="48"
      viewBox="0 0 158 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.916992 0V8.16838L17.2753 13.4563L29.9503 9.37214V9.35065L0.916992 0Z"
        fill="#8BD3E6"
      />
      <path
        d="M0.916992 10.5548V18.7232L13.6137 14.639L0.916992 10.5548Z"
        fill="#8BD3E6"
      />
      <path
        d="M17.2749 23.9896L29.9499 19.9054L26.2883 18.7231L13.6133 22.8073L17.2749 23.9896Z"
        fill="#8BD3E6"
      />
      <path
        d="M17.2749 34.5436L29.9499 30.4594L26.2883 29.2771L13.6133 33.3613L17.2749 34.5436Z"
        fill="#8BD3E6"
      />
      <path
        d="M9.93033 23.9896L0.916992 26.913V29.2776L13.6137 25.1934L9.93033 23.9896Z"
        fill="#8BD3E6"
      />
      <path
        d="M0.916992 29.2771V37.4455L13.6137 33.3613L0.916992 29.2771Z"
        fill="#343741"
      />
      <path
        d="M13.6133 25.1934L26.2883 29.2776L29.9499 28.0953V28.0738L17.2749 23.9896L13.6133 25.1934Z"
        fill="#343741"
      />
      <path
        d="M29.9504 28.0738V19.9054L17.2754 23.9896L29.9504 28.0738Z"
        fill="#0084D4"
      />
      <path
        d="M0.916992 29.2771L13.6137 33.3613L26.2887 29.2771L13.6137 25.1929L0.916992 29.2771Z"
        fill="#0084D4"
      />
      <path
        d="M0.916992 39.8099V47.9998L29.9503 38.6277L17.2753 34.5435L0.916992 39.8099Z"
        fill="#343741"
      />
      <path
        d="M29.9504 38.6276V30.4592L17.2754 34.5434L29.9504 38.6276Z"
        fill="#0084D4"
      />
      <path
        d="M13.6133 14.6391L26.2883 18.7232L29.9499 17.541L17.2749 13.4568L13.6133 14.6391Z"
        fill="#343741"
      />
      <path
        d="M13.6137 22.8073L0.916992 18.7231V21.0877L9.93033 23.9896L13.6137 22.8073Z"
        fill="#343741"
      />
      <path
        d="M29.9504 17.5409V9.37256L17.2754 13.4567L29.9504 17.5409Z"
        fill="#0084D4"
      />
      <path
        d="M0.916992 18.7231L13.6137 22.8073L26.2887 18.7231L13.6137 14.6389L0.916992 18.7231Z"
        fill="#0084D4"
      />
      <path
        d="M0.916992 21.0876V26.913L9.93032 23.9896L0.916992 21.0876Z"
        fill="#0084D4"
      />
      <path
        d="M39.3535 30.2873V17.9917H46.5685V19.9908H41.7152V22.8712H45.9402L45.5285 24.8918H41.7152V28.2882H46.5685V30.2873H39.3535Z"
        fill="#0084D4"
      />
      <path
        d="M59.5686 30.2873L53.7403 21.8179V30.2873H51.5303V17.9917H53.7836L59.3303 26.0311V17.9917H61.5403V30.2873H59.5686Z"
        fill="#0084D4"
      />
      <path
        d="M72.6333 30.3303H70.2933L65.6133 17.8843H68.2566L71.5499 27.2779L74.7999 17.9918H77.2916L72.6333 30.3303Z"
        fill="#0084D4"
      />
      <path
        d="M98.1129 30.4165C96.7696 30.438 95.4262 30.137 94.2129 29.5781L94.5812 27.4285C95.6212 28.0304 96.9212 28.5033 98.1562 28.5033C99.2612 28.5033 99.9979 27.9874 99.9979 26.9986C99.9979 26.0958 99.5646 25.7089 97.7662 24.9565C95.3612 23.9677 94.3862 23.1939 94.3862 21.2808C94.3862 19.1097 96.0762 17.8415 98.3946 17.8415C99.5212 17.82 100.648 18.0779 101.666 18.5938L101.32 20.7219C100.453 20.1415 99.4346 19.7976 98.3946 19.7546C97.2029 19.7546 96.6829 20.335 96.6829 21.0658C96.6829 21.8397 97.0729 22.2266 98.8062 22.9359C101.363 23.9677 102.295 24.8491 102.295 26.7407C102.273 29.1697 100.496 30.4165 98.1129 30.4165Z"
        fill="#0084D4"
      />
      <path
        d="M112.218 20.0338V30.2873H109.813V20.0338H106.151V17.9917H115.988L115.533 20.0338H112.218Z"
        fill="#0084D4"
      />
      <path
        d="M128.338 30.2873L122.51 21.8179V30.2873H120.3V17.9917H122.553L128.1 26.0311V17.9917H130.31V30.2873H128.338Z"
        fill="#0084D4"
      />
      <path
        d="M152.99 20.0338V30.2873H150.606V20.0338H146.923V17.9917H156.651L156.196 20.0338H152.99Z"
        fill="#0084D4"
      />
      <path
        d="M81.8418 30.2449V17.9708H89.0351V19.9699H84.2035V22.8504H88.4285L88.0168 24.871H84.2035V28.2673H89.0568V30.2449H81.8418Z"
        fill="#0084D4"
      />
      <path
        d="M135.835 30.2873V17.9917H143.028V19.9908H138.175V22.8712H142.4L141.988 24.9133H138.175V28.2882H143.05V30.2873H135.835Z"
        fill="#0084D4"
      />
    </svg>
  );
}

export default Logo;
